import gsap from 'gsap';

import App from '../../assets/js/app';

import AnimationController from '../../assets/js/controllers/animation';
import DetectController from '../../assets/js/controllers/detect';
import ResizeController from '../../assets/js/controllers/resize';
import ScrollController from '../../assets/js/controllers/scroll';

export default class Header {

	static selector = 'header';

	el = {};

	isDesktop;

	animation;

	height = 0;
	eased = 0;
	translate = 0;

	constructor(container) {
		this.el = {
			container,
			anchors: container.querySelectorAll(`.${this.constructor.selector} nav a`)
		};

		this.isTablet = DetectController.isTablet;

		if (!this.isTablet) {
			this.el.hamburger = container.querySelector(`.${this.constructor.selector}__mobile-hamburger`);
			this.el.close = container.querySelector(`.${this.constructor.selector}__mobile-close`);
			this.el.nav = container.querySelector(`.${this.constructor.selector} nav`);
		}

		this.measure();
		this.start();
		this.addEventListeners();
	}

	addEventListeners() {
		if (!this.isTablet) {
			this.el.close.addEventListener('click', this.#onCloseClick);
			this.el.hamburger.addEventListener('click', this.#onHamburgerClick);

			for (const anchor of this.el.anchors) {
				anchor.addEventListener('click', this.#onAnchorClick);
			}
		}

		ResizeController.add(this.#onResize);
	}

	removeEventListeners() {
		if (!this.isTablet) {
			this.el.close.removeEventListener('click', this.#onCloseClick);
			this.el.hamburger.removeEventListener('click', this.#onHamburgerClick);

			for (const anchor of this.el.anchors) {
				anchor.removeEventListener('click', this.#onAnchorClick);
			}
		}

		ResizeController.remove(this.#onResize);
	}

	#onResize = () => {
		this.measure();
	}

	#onAnchorClick = () => {
		this.hideMobileNav();
	}

	#onHamburgerClick = () => {
		App.freeze();

		this.timelineShow = gsap.timeline();
		this.timelineShow
			.set(this.el.nav, {
				display: 'flex'
			})
			.fromTo(this.el.nav, {
				autoAlpha: 0
			}, {
				ease: 'power3.inOut',
				autoAlpha: 1,
				duration: 0.25
			});
	}

	#onCloseClick = () => {
		this.hideMobileNav();
	}

	hideMobileNav() {
		App.thaw();

		this.timelineHide = gsap.timeline();
		this.timelineHide
			.fromTo(this.el.nav, {
				autoAlpha: 1
			}, {
				ease: 'power3.inOut',
				autoAlpha: 0,
				duration: 0.25
			})
			.set(this.el.nav, {
				display: 'none'
			});
	}

	measure() {
		this.height = this.el.container.offsetHeight;
	}

	update = () => {
		let { translate } = this;
		// const eased = ScrollController.eased * 1.5;
		const { eased } = ScrollController;
		const difference = eased - this.eased;
		this.eased = eased;
		if (this.eased < 0) this.eased = 0;
		translate += difference;
		if (translate < 0) translate = 0;
		if (translate > this.height) translate = this.height;
		if (translate !== this.translate) {
			this.translate = translate;
			ScrollController.sticky.offset = this.height - translate;
			return true;
		}
	}

	render = () => {
		this.el.container.style.transform = `matrix(1, 0, 0, 1, 0, -${this.translate})`;
	}

	start() {
		this.animation = AnimationController.set({
			update: this.update,
			render: this.render
		});
	}

	pause() {
		AnimationController.clear(this.animation);
	}

	activate(page) {
		for (const anchor of this.el.anchors) {
			anchor.classList[anchor.dataset.page === page ? 'add' : 'remove']('is-active');
		}
	}

	destroy() {
		this.pause();
		this.removeEventListeners();
	}

}
